import { AstraSkeletonLoader } from '~/astra'

const SkeletonStatusItem = () => (
    <div className="flex items-center gap-2 rounded-md py-1">
        <div className="h-6 w-11 rounded-md">
            <AstraSkeletonLoader />
        </div>
        <div className="h-5 w-32">
            <AstraSkeletonLoader />
        </div>
    </div>
)

const SkeletonStatusGroup = ({ itemCount }: { itemCount: number }) => (
    <div className="mx-4 flex flex-col gap-2">
        <div className="flex items-center justify-between rounded-md bg-surface-strong px-3 py-2">
            <div className="h-5 w-24">
                <AstraSkeletonLoader />
            </div>
            <div className="h-8 w-8 rounded-md">
                <AstraSkeletonLoader />
            </div>
        </div>

        <div className="flex flex-col gap-1">
            {Array.from({ length: itemCount }, (_, i) => (
                <SkeletonStatusItem key={i} />
            ))}
        </div>
    </div>
)

export const StatusesSkeleton = () => (
    <div className="flex h-full min-h-0 flex-col gap-4 overflow-auto">
        <SkeletonStatusGroup itemCount={4} />
        <SkeletonStatusGroup itemCount={3} />
        <SkeletonStatusGroup itemCount={2} />
    </div>
)
